import { TextField, Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { palette } from "../../../theme/palette";
import { FULL_DAYS } from "../../../consts/strings";
import { DRIVER_MANAGEMENT } from "../../../consts/routes";

import { getSelectedDepot } from "../../../reducers/ownApp/selectors";

import { View } from "../../View";
import { DriverLabel } from "../../DriverDetail/DriverLabel";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  topContainer: {
    display: "flex",
    padding: "1rem 2.5rem",
    gap: "2rem",
  },
  bottomContainer: {
    display: "flex",
    padding: "0rem 0.5rem",
    margin: "0.25rem 0rem",
    minHeight: "5rem",
  },
  header: {
    paddingLeft: "2rem",
    margin: "0.25rem 0rem",
    fontWeight: "bold",
  },
  dayDriversContainer: {
    display: "flex",
    flexDirection: "column",
    margin: "0rem 1rem",
    width: "12rem",
    cursor: "pointer",
  },
  driverContainer: {
    display: "flex",
    gap: "0.25rem",
    height: "1.25rem",
    margin: "0.3rem 0rem",
  },
  driverNameContainer: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    textWrap: "nowrap",
  },
  blueButton: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
  },
});

export const SectionManagementModalContent = ({
  section,
  onChange,
  onSetAsDefault,
  disabled,
  errors,
}) => {
  const styles = useStyles();
  const navigate = useNavigate();

  const selectedDepot = useSelector(getSelectedDepot);

  return (
    <View className={styles.container}>
      <View className={styles.topContainer}>
        <TextField
          variant={"outlined"}
          label={"Section Name"}
          name={"sectionName"}
          value={section.sectionName || ""}
          FormHelperTextProps={{
            style: { marginLeft: "0px", marginBottom: "-0.5rem" },
          }}
          error={!!errors["sectionName"]}
          helperText={errors["sectionName"]}
          disabled={disabled}
          onChange={({ target: { name, value } }) => onChange({ name, value })}
        />
        <Button
          className={styles.blueButton}
          variant={"contained"}
          onClick={onSetAsDefault}
          disabled={disabled || section.defaultSection}
        >
          Set as Default
        </Button>
      </View>
      <View className={styles.bottomContainer}>
        {[1, 2, 3, 4, 5, 6, 0].map((dayOfWeek) => {
          const { drivers } = section.days[dayOfWeek];
          return (
            <View className={styles.dayDriversContainer} key={dayOfWeek}>
              <View className={styles.header} key={dayOfWeek}>
                {FULL_DAYS[dayOfWeek]}
              </View>
              {drivers.map((driver) => (
                <View
                  className={styles.driverContainer}
                  key={`${dayOfWeek}-${driver.driverCode}`}
                  onClick={() => {
                    navigate(
                      `${DRIVER_MANAGEMENT}/?${new URLSearchParams({
                        depotCode: selectedDepot,
                        driverCode: driver.driverCode,
                      }).toString()}`,
                      { replace: true }
                    );
                  }}
                >
                  <DriverLabel driver={{ ...driver, isActive: true }} />
                  <View className={styles.driverNameContainer}>
                    {`${driver.driverName}`}
                  </View>
                </View>
              ))}
            </View>
          );
        })}
      </View>
    </View>
  );
};
